import styled from 'styled-components';

const Footnote = styled.div`
  font-size: 14px;
  padding: 15px 5px 0;
  color: #999;
`;

export default Footnote;



// WEBPACK FOOTER //
// ./src/components/Footnote/index.js